// extracted by mini-css-extract-plugin
module.exports = {"best_practice_section":"BestPractice_best_practice_section__1Hz7C","best_practice_wrapper":"BestPractice_best_practice_wrapper__3yHVj"};